/**
 * Google API Safety Utilities
 * Prevents "Cannot read properties of undefined (reading 'google')" errors
 */

// Initialize window.google as an empty object if it doesn't exist
// This prevents errors when code tries to access window.google properties
export const ensureGoogleSafety = () => {
  if (typeof window !== 'undefined') {
    // Check if google exists
    if (!window.google) {
      // Create a safe stub for google object
      (window as any).google = {
        accounts: {
          id: {
            initialize: () => {
              console.debug('Google Sign-In stub: initialize called (script not yet loaded)');
            },
            renderButton: () => {
              console.debug('Google Sign-In stub: renderButton called (script not yet loaded)');
            },
            prompt: () => {
              console.debug('Google Sign-In stub: prompt called (script not yet loaded)');
            },
            disableAutoSelect: () => {
              console.debug('Google Sign-In stub: disableAutoSelect called (script not yet loaded)');
            },
          },
          oauth2: {
            initTokenClient: () => {
              console.debug('Google OAuth2 stub: initTokenClient called (script not yet loaded)');
              return {
                requestAccessToken: () => {
                  console.debug('Google OAuth2 stub: requestAccessToken called (script not yet loaded)');
                },
              };
            },
          },
        },
        maps: null,
      };
    } else {
      // Google exists, but ensure accounts.id exists
      if (!window.google.accounts) {
        (window as any).google.accounts = {
          id: {
            initialize: () => {
              console.debug('Google Sign-In stub: initialize called (partial load)');
            },
            renderButton: () => {
              console.debug('Google Sign-In stub: renderButton called (partial load)');
            },
            prompt: () => {
              console.debug('Google Sign-In stub: prompt called (partial load)');
            },
            disableAutoSelect: () => {
              console.debug('Google Sign-In stub: disableAutoSelect called (partial load)');
            },
          },
          oauth2: {
            initTokenClient: () => {
              console.debug('Google OAuth2 stub: initTokenClient called (partial load)');
              return {
                requestAccessToken: () => {
                  console.debug('Google OAuth2 stub: requestAccessToken called (partial load)');
                },
              };
            },
          },
        };
      } else if (!window.google.accounts.id) {
        (window as any).google.accounts.id = {
          initialize: () => {
            console.debug('Google Sign-In ID stub: initialize called (accounts exists)');
          },
          renderButton: () => {
            console.debug('Google Sign-In ID stub: renderButton called (accounts exists)');
          },
          prompt: () => {
            console.debug('Google Sign-In ID stub: prompt called (accounts exists)');
          },
          disableAutoSelect: () => {
            console.debug('Google Sign-In ID stub: disableAutoSelect called (accounts exists)');
          },
        };
      }
    }
  }
};

// Also ensure gtag is safe
export const ensureGtagSafety = () => {
  if (typeof window !== 'undefined' && !window.gtag) {
    // Create a safe stub for gtag
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).gtag = function() {
      (window as any).dataLayer.push(arguments);
    };
    console.debug('Google Analytics (gtag) stub initialized');
  }
};

// Call this early in the app lifecycle
ensureGoogleSafety();
ensureGtagSafety();
